import React from 'react'

const Header = () => {
  return (<>
    <div className='APP_HEADER'></div>
  </>)
}

export default Header